import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import BufferTool from "../GisTools/BufferTool";
import ChangeTool from "../GisTools/ChangeTool";
import MapComponent from "../../componets/MapComponent";
import GisChart from "../GisTools/GisChart";
import SoloarPotential from "../GisTools/SoloarPotential";
import GisQuery from "../GisTools/GisQuery";
import ComparisonTools from "../GisTools/ComparisonTools";
import KMLAnalysisComponent from "../GisTools/KMLAnalysisComponent";

import GisQueryAnalysis from "../GisTools/GisQueryAnalysis";
import SCADAHome from "../GisTools/SCADAHome";
import SCADA from "../GisTools/SCADA";
import SCADADashboard from "../GisTools/SCADADashboard";

import Modal from 'react-bootstrap/Modal';
import ByDefault from '../GisTools/ByDefault'
import { useDispatch, useSelector } from "react-redux";
import { currentStageData, reSetMap, setIsSidebar, setIsToolsHeight } from "../../store/slice/currentStageSlice";
import { setFeatureTable } from "../../store/slice/bufferSlice";
import MapChangeAnalysis from "../../componets/MapChangeAnalysis";
import MapUlbView from "../../componets/MapUlbView";
import { useNavigate, useLocation } from "react-router-dom";
import PropertyChangeMap2 from "../GisTools/PropertyChangeMap2";
import PropertyChangeMap3 from "../GisTools/PropertyChangeMap3";
import useData from "../../assests/js/useData";
import IdentifiedProperty from "../GisTools/IdentifiedProperty";
import MapNewProperty2 from "../GisTools/MapNewProperty2";
import ABPass from "../GisTools/ABPass";
import PropertyExplorer from "../../componets/PropertyExplorer";
import PropertyInfo from "../GisTools/PropertyInfo";



function GisDashboard() {
    const [view, setView] = useState(null);
    const { isBufferWidth, isToolHeight, isSideBar, currentStageValue, resetMapTrigger } = useSelector((state) => state.currentStage);
    const [selectedLayer, setSelectedLayer] = useState("");
    const [currentStage, setCurrentStage] = useState(0);
    const [isByDefaultActive, setIsByDefaultActive] = useState(true);
    const [isScreenSize, setIsScreenSize] = useState(window.innerWidth <= 991);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [bufferFeatures, setBufferFeatures] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isChangeStage, setIsChangeStage] = useState(false);
    const [pendingStage, setPendingStage] = useState(null);
    const { isWidth } = useSelector((state) => state.currentStage);
    const { isTheme } = useSelector((state) => state.currentStage)
    const [isGetPermission, setIsGetPermission] = useState([]);
    const authData = useSelector(state => state.authToken.authData);
    const permissionsGet = useSelector((state) => state.permissions.permissions);
    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [selectedTool, setSelectedTool] = useState(null);
    const [activeLang, setActiveLang] = useState("en");
    const handleLayerSelect = (layer) => {
        setSelectedLayer(layer);
    };

    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const type = queryParams.get("type"); // "1" or "2"

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <div className={props.currentSlide == 5 ? "d-none" : "slick-arrow slick-next"} onClick={onClick}>
                {isTheme === "light" ? <img src="img/right-arrow-light.svg" alt="image" /> :
                    <img src="img/right-arrow.svg" alt="image" />}
            </div>
        );
    };

   

    const openModal = (tool) => {
        setSelectedTool(tool); // pass tool data into modal if needed
        setIsModalOpen(true);
    };


    const PrevArrow = (props) => {
        const { onClick } = props;
        return (
            <div className={props.currentSlide == 0 ? 'd-none' : "slick-arrow slick-prev"} onClick={onClick}>
                {isTheme === "light" ? <img src="img/left-arrow-light.svg" alt="image" /> :
                    <img src="img/left-arrow.svg" alt="image" width="20px" height="20px" />}
            </div>
        );
    };




    const toolsConfig = [
        {
            id: 1,
            name: "Search my Property",
            icon: "img/propertysearch.svg",
            className: isTheme === 'light' ? '#FDE3E1' : '#FFF',
            status: true,
            activityId: 'G1'
        },
        {
            id: 2,
            name: "Buffer Analysis Tool",
            icon: "img/Rectanglebuffer.png",
            component: <BufferTool
                onLayerSelect={handleLayerSelect} view={view}
                bufferFeatures={bufferFeatures}
                setView={setView}
            />,
            className: isTheme === 'light' ? '#F1ECE1' : '#FFF',
            status: true,
            activityId: 'G2'
        },

        {
            id: 3,
            name: "Identify New Properties",
            icon: "img/identity-new-roperty.svg",
            className: isTheme === 'light' ? '#E1F3FF' : '#FFF',
            status: true,
            activityId: 'G3'
        },

        {
            id: 4,
            name: "Geo-Info Query",
            icon: "img/Rectangleloc.png",
            component: <GisQuery onLayerSelect={handleLayerSelect} view={view} />,
            className: isTheme === 'light' ? '#D9F0ED' : '#FFF',
            status: true,
            activityId: 'G4'
        },



        {
            id: 5,
            name: "Tax Paid/ Unpaid",
            icon: "img/comprison.svg",
            component: <ComparisonTools />,

            className: isTheme === 'light' ? '#FDF6DD' : '#FFF',
            status: true,
            activityId: 'G5'
        },


        {
            id: 6,
            name: "Tax Evaluation Analysis",
            icon: "img/Rectangleware.png",
            // component: <HighLowTaxWord onLayerSelect={handleLayerSelect} view={view} bufferFeatures={bufferFeatures} />,
            className: isTheme === 'light' ? '#FDF6DD' : '#FFF',
            status: true,
            activityId: 'G6'
        },
        {
            id: 7,
            name: "Change Analysis Tool",
            icon: "img/Rectanglechange.png",
            component: <ChangeTool
              onLayerSelect={handleLayerSelect} view={view} />,
            className: isTheme === 'light' ? '#E6E9FF' : '#FFF',
            status: true,
            activityId: 'G7'
        },

        {
            id: 8,
            name: "View ULB/Print Map",
            icon: "img/Rectanglesacler.png",
            component: <SoloarPotential view={view} />,
            className: isTheme === 'light' ? '#E1F3FF' : '#FFF',
            status: true,
            activityId: 'G8'
        },

        {
            id: 9,
            name: "Master Plan Analysis",
            icon: "img/waterrise.svg",
            // component: <WaterLavel />,
            className: isTheme === 'light' ? '#FDE3E1' : '#FFF',
            // title: "Wrok in progess",
            status: true,
            activityId: 'G9'
        },

        {
            id: 10,
            name: "ABPAS Analysis",
            icon: "img/propertysearch.svg",
            // component: <WaterQuality />,
            className: isTheme === 'light' ? '#E1F3FF' : '#FFF',
            // title: "Wrok in progess",
            activityId: 'G10',
            status: true,
        },
        {
            id: 14,
            name: "GIS Intersection  Analysis",
            icon: "img/Rectangleloc.png",
            // component: <WaterQuality />,
            className: isTheme === 'light' ? '#E1F3FF' : '#FFF',
            // title: "Wrok in progess",
            activityId: 'G10',
            status: true,
        },
        {
            id: 12,

            name: "Load KML Overlay Analysis ",
            icon: "img/propertysearch.svg",
            //component: <ByDefault onLayerSelect={handleLayerSelect} view={view} />, // Replace with the actual component
            className: isTheme === 'light' ? '#afccb9ff' : '#e9e9ecff',
            status: true,
            activityId: 'G1'

        },
        {
            id: 13,
            name: "SCADA Analysis",
            icon: "img/waterquality.svg",
           // Replace with the actual component
            className: isTheme === 'light' ? '#FDE3E1' : '#FFF',
            status: true,
            activityId: 'G10'

        },

        {
            id: 15,
            name: " Scada Details",
            icon: "img/waterquality.svg",
           // Replace with the actual component
            className: isTheme === 'light' ? '#FDE3E1' : '#FFF',
            status: true,
            activityId: 'G10'

        },
        {
            id: 16,
            name: "STP live Detail's",
            icon: "img/waterquality.svg",
            className: isTheme === 'light' ? '#E1F3FF' : '#FFF',
            status: true,
            activityId: 'G10'
        },
        {
            id: 17,
            name: "WTP Reports",
            icon: "img/waterquality.svg",
            className: isTheme === 'light' ? '#E1F3FF' : '#FFF',
            status: true,
            activityId: 'G10'
        },
        {
            id: 19,
            name: "STP Reports",
            icon: "img/waterquality.svg",
            className: isTheme === 'light' ? '#E1F3FF' : '#FFF',
            status: true,
            activityId: 'G10'
        },
        {
            id: 11,
            name: "Tax Evaluation Analysis",
            icon: "img/Rectangleware.png",
            // component: <HighLowTaxWord onLayerSelect={handleLayerSelect} view={view} bufferFeatures={bufferFeatures} />,
            className: isTheme === 'light' ? '#FDF6DD' : '#FFF',
            status: true,
            activityId: 'G11'
        },
        {
            id: 18,
            name: "Simhastha",
            icon: "img/Rectangleware.png",
            // component: <HighLowTaxWord onLayerSelect={handleLayerSelect} view={view} bufferFeatures={bufferFeatures} />,
            className: isTheme === 'light' ? '#FDF6DD' : '#FFF',
            status: true,
            activityId: 'G18'
        },
    ];

    const permittedTools = toolsConfig.filter(tool =>
        isGetPermission.some(p => p.activityId === tool.activityId)
    );

    const visibleSlides = Math.min(permittedTools.length, 6);



    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: visibleSlides,
        slidesToScroll: visibleSlides,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1350,
                settings: {
                    slidesToShow: Math.min(permittedTools.length, 4),
                    slidesToScroll: Math.min(permittedTools.length, 4)
                },
            },
            {
                breakpoint: 1090,
                settings: {
                    slidesToShow: Math.min(permittedTools.length, 3),
                    slidesToScroll: Math.min(permittedTools.length, 3)
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: Math.min(permittedTools.length, 2),
                    slidesToScroll: Math.min(permittedTools.length, 2)
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                },
            },
        ],
    };

    const renderToolComponent = () => {
        if (isByDefaultActive || currentStageValue === 0) {
            return <GisChart onLayerSelect={handleLayerSelect} view={view} />;
        }
        const selectedTool = toolsConfig.find((tool) => tool.id === currentStage);
        return selectedTool ? selectedTool.component : null;
    };

    const handleToolClick = (tool) => {
        if (currentStage === 0 && tool.id !== 0) {
            setPendingStage(tool.id);
            // setIsChangeStage(true);
            applyStageChange(tool.id);
            return;
        }
        if (tool.id !== currentStage) {
            setPendingStage(tool.id);
            // setIsChangeStage(true);
            applyStageChange(tool.id);
        } else {
            applyStageChange(tool.id);
        }
    };

    //code for propety search

    const applyStageChange = (stageId) => {
        console.log("stageId", stageId)
        setCurrentStage(stageId);
        setIsByDefaultActive(false);
        dispatch(currentStageData(stageId));
        // setIsChangeStage(false);
        dispatch(setFeatureTable([]))
        dispatch(reSetMap())
        dispatch(setIsToolsHeight(!isToolHeight));
        if (stageId === 3 || stageId === 5 || stageId === 6 || stageId === 9 || stageId === 1) {
            dispatch(setIsSidebar(true));
        } else {
            dispatch(setIsSidebar(false));
        }

    };


    useEffect(() => {
        const handleResize = () => {
            setIsScreenSize(window.innerWidth <= 991);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (currentStageValue !== 0 && currentStageValue !== null) {
            setCurrentStage(currentStageValue);
            setIsByDefaultActive(false);
        }
    }, [currentStageValue]);

    const handleToggleToolsHeight = () => {
        dispatch(setIsToolsHeight(!isToolHeight));
    };

    useEffect(() => {
        // fetchUserPermission()
        setIsGetPermission(permissionsGet)
    }, [permissionsGet])

     useEffect(() => {
        if (view) {
            if (type === "115") {
                applyStageChange(7);
            } else if (type === "7") {
                applyStageChange(2);
            } else if (type === "8") {
                applyStageChange(8);
            }
        }
    }, [type, view])

    return (
        <div>

            

            <div className="mid-dashboard">
                <div className={isWidth && !isScreenSize ? 'w-100' : isBufferWidth  || currentStageValue === 3 || currentStageValue === 0 || currentStageValue === 6 || currentStageValue === 5 || currentStageValue === 10 || currentStageValue === 9 ||
                 currentStageValue === 1 || currentStageValue === 12 || currentStageValue === 13  || currentStageValue === 15 || currentStageValue === 16 || currentStageValue === 17 || currentStageValue === 19 || currentStageValue === 18 ||
                 currentStageValue === 14 ? "is-mapcomponent" : "mapcomponent"}    >
                    
                    
                    {  
                     
                        currentStageValue === 1 ?
                               <PropertyInfo />
                             :                      
                        currentStageValue === 2 ?
                                <MapComponent selectedLayer={selectedLayer}
                                                           onViewReady={(mapView) => setView(mapView)}
                                                           isWidth={isWidth} isScreenSize={isScreenSize}
                                                           isByDefaultActive={isByDefaultActive}
                                                        />
                              :
                        currentStageValue === 3 ?
                        <>
                            <IdentifiedProperty />                    
                        </>
                            :
                        currentStageValue === 5 ?
                         <>
                             <PropertyChangeMap2 />
                         </>
                            :
                        currentStageValue === 6 ?
                        <>
                             <PropertyChangeMap3 />
                        </>
                            :                        
                        currentStageValue === 7 ?
                         <>
                             <MapChangeAnalysis  onViewReady={(mapView) => setView(mapView)} />
                         </>
                             :
                        currentStageValue === 8 ?
                        <>  
                              <MapUlbView onViewReady={(mapView) => setView(mapView)} />
                        </>
                             :
                         currentStageValue === 9 ?                                               
                                <MapNewProperty2 />  
                             :                        
                        currentStageValue === 10 ?
                                   <ABPass />                                 
                                : 
                        currentStageValue === 12 ?
                                   <KMLAnalysisComponent />
                                :  
                                
                        currentStageValue === 13 ?
                        <>
                            <SCADAHome />                 
                        </>

                                 :
                                  currentStageValue === 15 ?
                        <>
                            <SCADADashboard />                 
                        </>

                                 :
                        currentStageValue === 16 ?
                            <iframe
                                src={`${process.env.PUBLIC_URL}/FloodSimulation.html`}
                                title="STP live Detail's"
                                style={{
                                    width: '100%',
                                    height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)',
                                    border: 0,
                                    display: 'block'
                                }}
                            />
                                 :
                        currentStageValue === 17 ?
                            <iframe
                                src={`${process.env.PUBLIC_URL}/WTPRTP.htm`}
                                title="WTP Reports"
                                style={{ width: '100%', height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)', border: 0, display: 'block' }}
                            />
                                 :
                        currentStageValue === 19 ?
                            <iframe
                                src={`${process.env.PUBLIC_URL}/STPRTP.htm`}
                                title="STP Reports"
                                style={{ width: '100%', height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)', border: 0, display: 'block' }}
                            />
                                 :
                        currentStageValue === 14 ?
                                <GisQueryAnalysis />                                 
                                 :
                                    // code for default Running 
                                 <MapComponent selectedLayer={selectedLayer}
                                                onViewReady={(mapView) => setView(mapView)}
                                                isWidth={isWidth} isScreenSize={isScreenSize}
                                                isByDefaultActive={isByDefaultActive} />


                    }

                </div>
                <div className={isWidth && !isScreenSize ? 'd-none' : isBufferWidth ||  currentStageValue === 3 || currentStageValue === 6 || currentStageValue === 5 || currentStageValue === 0 || currentStageValue === 9 || currentStageValue === 1 || currentStageValue === 10 || currentStageValue === 14 || currentStageValue === 12 ||currentStageValue === 13 || currentStageValue === 15 || currentStageValue === 16 || currentStageValue === 17 || currentStageValue === 19 || currentStageValue === 18 ? "is-rendercomponent " : 'button-tools rendercomponent'}>
                    <div className="dashboard-tools">{renderToolComponent()}</div>
                </div>
            </div>


            <div className={isWidth && !isScreenSize ? 'd-none' : isToolHeight ? "manage-divtools" : 'd-content'} style={{ backgroundColor: "white" }}>
                <div className="d-flex justify-content-between">
                    <h6 className="sidebarbuttontitle m-0 px-2 text-black">Tools</h6>
                    <div className="tooltitlediv linear-gradian-bg p-0 mb-1 mt-0 hideshowbtn">
                        <h6 className="showtoolstext m-0 px-3 text-white" type="button" onClick={handleToggleToolsHeight}>{isToolHeight ? "Show tools" : "Hide tools"}</h6>
                    </div>
                </div>

                <div className={isToolHeight ? "d-none" : "col-md-12 px-4 overflow-hidden toolsslider"}>
                    <Slider {...settings}>
                        {toolsConfig
                            .filter(tool =>
                                isGetPermission.some(p => p.activityId === tool.activityId)
                            )
                            .map((tool) => (
                                <div key={tool.id} className="tool-card">
                                    <div
                                        type="button"
                                        onClick={() => tool.status && handleToolClick(tool)} // card click
                                        className={`tool-btn ${tool.status ? '' : 'disabled'} ${currentStageValue !== 0 && currentStage === tool.id ? "active toolbtnboarder" : ""}`}
                                        style={{
                                            backgroundColor: tool.className,
                                            color: tool.colorName,
                                            position: "relative",
                                            opacity: tool.status ? 1 : 0.5,
                                            cursor: tool.status ? 'pointer' : 'not-allowed',
                                            pointerEvents: tool.status ? 'auto' : 'none'
                                        }}
                                        title={!tool.status ? 'Coming Soon' : ''}
                                    >
                                        {currentStageValue !== 0 && currentStage === tool.id && (
                                            <div className="activetoolcard">
                                                <img src="img/active-card.svg" alt="card" />
                                            </div>
                                        )}

                                        <div>
                                            <div className="d-flex gap-2">
                                                <img src={tool.icon} alt={tool.name} width="28px" height="28px" />
                                                <button
                                                    type="button"
                                                    className="btn-tooltip"
                                                    // className="btn btn-sm btn-light mt-2"
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // stop card click
                                                        openModal(tool);     // your modal function
                                                    }}
                                                >
                                                    <img src='img/tools-tooltip.svg' alt="tooltip" width="16px" height="16px" />
                                                </button>
                                            </div>
                                            {/* <img src='img/tools-tooltip.svg' alt="tooltip" width="16px" height="16px" /> */}


                                            <h6 className="mt-2 mb-0 progress-title">{tool.title}</h6>
                                            <h6 className="mt-2 mb-0">{tool.name}</h6>


                                        </div>



                                        {/* 🔹 Add a button ONLY for modal */}

                                    </div>
                                </div>
                            ))}
                    </Slider>
                </div>

            </div>



            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isModalOpen}
                className="addusermodal"

            >
                <Modal.Header className="position-relative"
                    style={{
                        backgroundColor: isTheme === 'light' && "white"
                    }}
                >
                    <Modal.Title id="contained-modal-title-vcenter" className="downloadtitle">
                        Download this current map
                    </Modal.Title>
                    <div style={{ position: 'absolute', right: '0' }} onClick={() => setIsModalOpen(false)}>
                        <img src="img/closebtn.svg" alt="Close" width="20px" height="20px" />
                    </div>
                </Modal.Header>
                <Modal.Body className="px-0 my-2"

                >
                    <div className="row justify-content-center">
                    </div>
                    <div className="row justify-content-center mt-2" style={{ rowGap: "20px" }}>
                        <div className="col-lg-3 col-md-4">
                            <button className='btn-down btn-text w-100 justify-content-center text-black'><img src="img/pdf-file.svg" alt='download' />Download PDF</button>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <button className='btn-down btn-text w-100 justify-content-center text-black'><img src="img/png-file.svg" alt='download' />Download PNG</button>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <button className='btn-down btn-text w-100 justify-content-center text-black'><img src="img/xml-file.svg" alt='download' />Download XML</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>


            <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isChangeStage}
                className="addusermodal"
            >
                <Modal.Header className="position-relative" style={{ backgroundColor: isTheme === "light" && "white" }}>
                </Modal.Header>
                <Modal.Body className="p-0 m-0">
                    <div className="text-center">
                        <img src="img/warning.svg" alt="warning" />
                        <h5 className="sure-text mt-2">Are you sure you want to switch tools?</h5>
                        <h6 className="switch-text">
                            Switching to another tool will discard your current data and progress. Do you want to continue?
                        </h6>
                    </div>
                    <div className="d-flex mt-2"
                        style={{
                            gap: "16px"
                        }}
                    >
                        <button className="btn-cancel w-100" onClick={() => setIsChangeStage(false)}>
                            Cancel
                        </button>

                        <button className="btn-modal-submit w-100" onClick={() => applyStageChange(pendingStage)}>
                            Yes, Switch Tool
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isModalOpen}
                onHide={() => setIsModalOpen(false)}
                className="addusermodal"
            >
                <Modal.Header closeButton>
                    <div className="d-flex align-items-center w-100 justify-content-between">
                        <div className="btn-group text-white">
                            <button
                                className={`btn ${activeLang === "en" ? "btn-modal-submit" : "btn-light border"}`}
                                onClick={() => setActiveLang("en")}
                            >
                                English
                            </button>
                            <button
                                // disabled
                                className={`btn ${activeLang === "hi" ? "btn-modal-submit" : "btn-light border"}`}
                                onClick={() => setActiveLang("hi")}
                            >
                                Hindi
                            </button>
                        </div>
                        <button className="btn"
                            onClick={() => setIsModalOpen(false)}
                        >
                            <img src="img/cancel-btn.svg" alt="cencel" width="32px" height="32px" />
                        </button>
                    </div>
                </Modal.Header>

                {/* <Modal.Body
                    className="p-3"
                    style={{
                        maxHeight: "70vh", // Max height relative to viewport
                        overflowY: "auto", // Enables vertical scrolling
                    }}
                >
                    <div className="tool-info">
                        {(() => {
                            const tool = useData.find((t) => t.title === selectedTool?.name);

                            if (!tool) return <p>Tool information not available</p>;

                            return (
                                <>
                                    <h5>{tool.title}</h5>

                                    {activeLang === "en" ? (
                                        <p>{tool.description || "No English description available."}</p>
                                    ) : (
                                        <p>{tool?.hindi?.description || "कोई हिंदी विवरण उपलब्ध नहीं है।"}</p>
                                    )}

                                    <h4>Use Cases:</h4>
                                    <ol>
                                        {tool.useCases?.map((step, i) => (
                                            <li key={i} dangerouslySetInnerHTML={{ __html: step }} />
                                        ))}
                                    </ol>

                                    <h4>How to use this tool?</h4>
                                    <ol>
                                        {tool.steps.map((step, i) => (
                                            <li key={i} dangerouslySetInnerHTML={{ __html: step }} />
                                        ))}
                                    </ol>

                                    {tool.additionalFeatures && (
                                        <>
                                            <h4>Additional Features:</h4>
                                            <ul>
                                                {tool.additionalFeatures.map((feature, idx) => (
                                                    <li key={idx}>{feature}</li>
                                                ))}
                                            </ul>
                                        </>
                                    )}

                                    <button
                                        className="btn-modal-submit w-100 text-white"
                                        onClick={() => setIsModalOpen(false)}
                                    >
                                        Run {tool.title}
                                    </button>
                                </>
                            );
                        })()}
                    </div>
                </Modal.Body> */}
                <Modal.Body
                    className="p-3"
                    style={{
                        maxHeight: "70vh", // Max height relative to viewport
                        overflowY: "auto", // Enables vertical scrolling
                    }}
                >
                    <div className="tool-info">
                        {(() => {
                            const tool = useData.find((t) => t.title === selectedTool?.name);

                            if (!tool) return <p>Tool information not available</p>;

                            const langData = activeLang === "en" ? tool : tool.hindi;

                            return (
                                <>
                                    <h5>{langData?.title || tool.title}</h5>

                                    <p>
                                        {langData?.description ||
                                            (activeLang === "en"
                                                ? "No English description available."
                                                : "कोई हिंदी विवरण उपलब्ध नहीं है।")}
                                    </p>

                                    <h4>{activeLang === "en" ? "Use Cases:" : "उपयोग के मामले:"}</h4>
                                    <ol>
                                        {(langData?.useCases || tool.useCases)?.map((step, i) => (
                                            <li key={i} dangerouslySetInnerHTML={{ __html: step }} />
                                        ))}
                                    </ol>

                                    <h4>
                                        {activeLang === "en"
                                            ? "How to use this tool?"
                                            : "इस टूल का उपयोग कैसे करें?"}
                                    </h4>
                                    <ol>
                                        {(langData?.steps || tool.steps)?.map((step, i) => (
                                            <li key={i} dangerouslySetInnerHTML={{ __html: step }} />
                                        ))}
                                    </ol>

                                    {langData?.additionalFeatures && (
                                        <>
                                            <h4>
                                                {activeLang === "en"
                                                    ? "Additional Features:"
                                                    : "अतिरिक्त विशेषताएँ:"}
                                            </h4>
                                            <ul>
                                                {langData.additionalFeatures.map((feature, idx) => (
                                                    <li key={idx}>{feature}</li>
                                                ))}
                                            </ul>
                                        </>
                                    )}

                                    <button
                                        className="btn-modal-submit w-100 text-white"
                                        onClick={() => setIsModalOpen(false)}
                                    >
                                        {activeLang === "en"
                                            ? `Run ${tool.title}`
                                            : `${tool.hindi?.title || tool.title} चलाएँ`}
                                    </button>
                                </>
                            );
                        })()}
                    </div>
                </Modal.Body>

            </Modal>




        </div>
    );
}

export default GisDashboard;
